























import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class FileUpload extends Vue {
  @Prop() private label!: string;
  @Prop() private labelPrefix!: string;
  @Prop() private labelSuffix!: string;
  @Prop({default: '*/*'}) private accept!: string;
  @Prop({default: false}) private multiple!: boolean;
  @Prop({default: false}) private hasFiles!: boolean;
  @Prop() private addMoreLabelText!: string;

  private get addMoreLabel(): string {
    return this.addMoreLabelText || this.label;
  }

  private uploadFile(file: any) {
    this.$emit('onupload', file);
  }
}
